export default "__VITE_ASSET__CehDZIce__"